import { action, observable, reaction } from 'mobx';
import { RoutingStore } from './RoutingStore';

interface HeaderStoreParams {
  routingStore: RoutingStore;
}

export class HeaderStore {
  private readonly routingStore: RoutingStore;

  @observable public isSticky: boolean = false;
  @observable public searchCriteria: string = '';
  @observable public isSearchInputFocused: boolean = false;

  constructor({ routingStore }: HeaderStoreParams) {
    this.routingStore = routingStore;

    const criteria =
      this.routingStore.matchedRoute.routeName === 'search' ? this.routingStore.matchedRoute.params.criteria : '';

    this.setSearchCriteria(criteria);

    this.listenForRouteChanges();
  }

  private listenForRouteChanges() {
    reaction(
      () => this.routingStore.matchedRoute,
      () => {
        if (!this.isSearchInputFocused) {
          // When navigating away from the search page, reset the search criteria.
          this.setSearchCriteria('');
        }
      },
    );
  }

  @action
  setSearchCriteria = (value: string) => {
    this.searchCriteria = value;
  };

  @action
  setIsSticky = (value: boolean) => {
    this.isSticky = value;
  };

  @action
  setSearchFocused = (value: boolean) => {
    this.isSearchInputFocused = value;
  };
}
